import apiURL from'./apiURL';
// const apiURL = `http://localhost:3000`;

// types of action
const Types = {
  WEBINAR_EVENTS_LOADED: "WEBINAR_EVENTS_LOADED",
};

const eventsLoaded = (payload) => ({
  type: Types.WEBINAR_EVENTS_LOADED,
  payload,
});

const getEventbriteEvents = () => {

  return (dispatch,getState) => {

    fetch(apiURL + `/settings/eventbrite/events` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(eventsLoaded(data))
    })

  }
};

const Actions = {
  getEventbriteEvents,
};


export {Types, Actions}